export class BiblereadcurrentdayPost {
    IdUser: number;
    Day: number;
    IdBibleReadPlan: number;
}
